import { motion } from "motion/react";
import { SquareArrowOutUpRight } from "lucide-react";

import { type AddressLight } from "shared/apiClient";
import { getText, interpolate, type LocalisationConfig } from "shared/lib";
import { animationVariants } from "@/components/wizard/widgets/lib";

import { CallOut } from "shared/components";
import { SiteOverview } from "@/components/siteOverview";

export interface DownForMaintenanceProps {
  address: AddressLight | undefined | null;
  localisationConfig: LocalisationConfig | undefined | null;
}

export function DownForMaintenance({
  address,
  localisationConfig,
}: DownForMaintenanceProps) {
  const renderFooter = () => {
    return (
      <motion.div
        variants={animationVariants}
        animate={["buttons"]}
        className="mt-3 flex flex-col items-end gap-2 md:mt-8"
      >
        <div className="flex gap-2">
          <a
            className="text-headingmd bg-primary text-primary-foreground hover:bg-primary/90 inline-flex h-9 items-center justify-center gap-2 whitespace-nowrap rounded-md px-3 py-2 font-normal"
            href={localisationConfig?.["councilContactLink"]}
            rel="noreferrer"
            tabIndex={0}
            target="_blank"
          >
            {getText("Talk to a planner")}
            <SquareArrowOutUpRight className="h-4 w-4" />
          </a>
        </div>
      </motion.div>
    );
  };

  return (
    <div
      className="wizard-step-transition flex h-full w-full flex-col gap-5 text-bodylg md:max-w-[600px]"
      data-testid="step-container-multi-select"
    >
      <div className="flex flex-col gap-3 md:gap-5">
        <h2 className="text-headingxl md:text-heading2xl text-textPrimary">
          {getText(
            "🚧 We're currently updating this service, please check back soon!",
          )}
        </h2>

        <CallOut className="border-interfaceBorder bg-interfaceBgDarkPaper text-bodylg">
          {interpolate(
            "Our updates usually don't take longer than an hour. For now, you can {{link}} about your proposal. We've also gathered some planning details about your entered address, which you can read below.",
            {
              link: (
                <a
                  className="text-textLink hover:text-textLinkHover inline-block items-center gap-1 underline"
                  href={localisationConfig?.["councilContactLink"]}
                  rel="noreferrer"
                  tabIndex={0}
                  target="_blank"
                >
                  {getText("talk to a planner")}{" "}
                  <SquareArrowOutUpRight className="inline-block h-4 w-4" />
                </a>
              ),
            },
          )}
        </CallOut>
      </div>

      <SiteOverview address={address} />

      {renderFooter()}
    </div>
  );
}
